import { useTranslation } from "react-i18next";
import NewCustomerTag from "../TagComponents/NewCustomerTag/NewCustomerTag";
import VCSTag from "../TagComponents/VCSTag/VCSTag";
import CustomerTypeTag from "../TagComponents/CustomerTypeTag/CustomerTypeTag";
import PrimaryTag from "../TagComponents/PrimaryTag/PrimaryTag";
import MigratedTag from "../TagComponents/MigratedTag/MigratedTag";
import "./CustomerTags.scss";

type Props = {
  isNewCustomer?: boolean;
  vcsFlag?: boolean;
  businessNatureCode?: number;
  isPrimary?: boolean;
  isNewInCurrentMonth?: boolean;
  isNewMigrated?: boolean;
  selectedPeriod: string;
  showVerifiedTag?: boolean;
  aboNo: string;
  registrationChannelCd: string;
};

const CustomerTags = (props: Props) => {
  useTranslation(["customers"]);
  const {
    isNewCustomer,
    vcsFlag,
    businessNatureCode,
    isPrimary,
    isNewInCurrentMonth,
    isNewMigrated,
    selectedPeriod,
    showVerifiedTag,
    aboNo,
    registrationChannelCd,
  } = props;
  return (
    <div className={`leaf-customer-tags leaf-customer-tags`}>
      <PrimaryTag isPrimary={isPrimary} />
      <NewCustomerTag
        isNewCustomer={isNewCustomer}
        isNewInCurrentMonth={isNewInCurrentMonth}
        isNewMigrated={isNewMigrated}
        selectedPeriod={selectedPeriod}
        aboNo={aboNo}
      />
      <MigratedTag isNewMigrated={isNewMigrated} aboNo={aboNo} />
      {showVerifiedTag && <VCSTag vcsFlag={vcsFlag} />}
      <CustomerTypeTag businessNatureCode={businessNatureCode} registrationChannelCd={registrationChannelCd} />
    </div>
  );
};

export default CustomerTags;
